import {DatePipe} from '@angular/common';

export function formatDateTimeToOnlyDateDisplay(dateTime: Date | string | null | undefined): string | null {
  if (!dateTime) return null;

  const date = new Date(dateTime);

  if (isNaN(date.getTime())) {
    return null;
  }

  return new DatePipe('en-US').transform(date, 'mediumDate');
}

export function formatDateTimeDisplay(dateTime: Date | string | null | undefined): string | null {
  if (!dateTime) return null;

  const date = new Date(dateTime);

  if (isNaN(date.getTime())) {
    return null;
  }

  return new DatePipe('en-US').transform(date, 'MMM d, y, h:mm a');
}

export function convertUtcToLocalDatetimeForInput(dateTimeOffset: string | Date): string | null {
  if (!dateTimeOffset) return null;

  try {
    const date = new Date(dateTimeOffset);
    if (isNaN(date.getTime())) return null;

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  } catch (error) {
    console.error('Error converting UTC to local datetime for form:', error);
    return null;
  }
}

export function convertLocalToUtcDateTimeOffset(localDateTime: string | null): string | null {
  if (!localDateTime) return null;

  try {
    const date = new Date(localDateTime);

    if (isNaN(date.getTime())) {
      console.warn('Invalid local datetime for conversion:', localDateTime);
      return null;
    }

    return date.toISOString();
  } catch (error) {
    console.error('Error converting local datetime to UTC:', error, localDateTime);
    return null;
  }
}
